import { render } from "./InputFile.vue?vue&type=template&id=bdd74afa&scoped=true"
import script from "./InputFile.vue?vue&type=script&lang=js"
export * from "./InputFile.vue?vue&type=script&lang=js"

import "./InputFile.vue?vue&type=style&index=0&id=bdd74afa&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd74afa"]])

export default __exports__